/* eslint-disable max-len,no-unused-vars,arrow-body-style,no-restricted-syntax */
import { debounce, get, cloneDeep } from 'lodash';
import { MARKET_DATA_MAP, CONTRACT_DATA_MAP } from '@/services/notifications/proxy';
import { updateContract, updateMarket, updateMarketContracts } from '@/utils/notifications';
import api from '@/services/api';
import constants from '@/constants';

const MAX_RELATED_MARKETS = 3;
const MARKET_DEBOUNCE_INTERVAL = 750;
const debounceGetMarket = debounce((dispatch, marketId) => {
  dispatch('getMarket', { marketId, skipCache: true });
}, MARKET_DEBOUNCE_INTERVAL);

const ITEMS_PER_HISTORY_PAGE = 10;
const DEFAULT_HISTORY = {
  data: null,
  marketId: -1,
  totalCount: -1,
  canLoadMore: true,
};

export default {
  namespaced: true,
  state: {
    marketIsEngineBusy: false,
    marketIsEngineBusyMessage: null,
    marketLoadError: false,
    market: null,
    contracts: [],
    contract: null,
    history: DEFAULT_HISTORY,
    isRulesOpen: false,
    related: [],
    chartTimeline: null,
    chartType: null,
    marketContractsStats: [],
    mapStateData: {},
    mapStateDataSenate: {},
    mapOverviewData: [],
    mapOverviewDataSenate: [],
    marketMapTooltipVisible: false,
  },
  getters: {
    getMarketHistoryData: (state) => {
      const historyData = state.history.data;
      return historyData === null ? [] : historyData;
    },
  },
  mutations: {
    setMarket(state, payload) {
      state.market = payload;
    },
    setContract(state, payload) {
      state.contract = payload;
    },
    setContracts(state, payload) {
      state.contracts = payload;
    },
    setMarketLoadError(state, payload) {
      state.marketLoadError = payload;
    },
    setMarketEngineBusyMessage(state, { isEngineBusy, isEngineBusyMessage }) {
      state.marketIsEngineBusy = isEngineBusy;
      state.marketIsEngineBusyMessage = isEngineBusyMessage;
    },
    updateMarketFromNotification(state, data) {
      state.market = updateMarket(state.market, data);
    },
    updateContractFromNotification(state, data) {
      if (state.market !== null && typeof state.market.contracts !== 'undefined') {
        // CONTRACTS SORT
        // contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        state.market = updateMarketContracts(state.market, data);
      }
      if (state.contracts !== null) {
        // CONTRACTS SORT
        // state.contracts.sort((prev, next) => {
        //   if (prev.lastTradePrice < next.lastTradePrice) {
        //     return 1;
        //   } else if (prev.lastTradePrice > next.lastTradePrice) {
        //     return -1;
        //   }
        //   return 0;
        // });
        const contracts = state.contracts.slice();
        state.contracts = contracts.map(contract => updateContract(contract, data));
      }
      if (state.contract !== null) {
        state.contract = updateContract(state.contract, data);
      }
    },
    updateMapOverviewDataFromNotification(state, data) {
      if (state.mapOverviewData.length > 0) {
        const mapOverviewData = state.mapOverviewData.slice();
        state.mapOverviewData = mapOverviewData.map(contract => updateContract(contract, data));
      }

      const mapStateData = cloneDeep(state.mapStateData);

      for (const stateCode of Object.keys(mapStateData)) {
        mapStateData[stateCode] = updateMarketContracts(mapStateData[stateCode], data);
      }

      state.mapStateData = mapStateData;
    },
    updateMapOverviewDataSenateFromNotification(state, data) {
      if (state.mapOverviewDataSenate.length > 0) {
        const mapOverviewData = state.mapOverviewDataSenate.slice();
        state.mapOverviewDataSenate = mapOverviewData.map(contract => updateContract(contract, data));
      }

      const mapStateData = cloneDeep(state.mapStateDataSenate);

      for (const stateCode of Object.keys(mapStateData)) {
        mapStateData[stateCode] = updateMarketContracts(mapStateData[stateCode], data);
      }

      state.mapStateDataSenate = mapStateData;
    },
    resetHistory(state) {
      state.history = DEFAULT_HISTORY;
    },
    updateHistory(state, payload) {
      state.history = {
        data: payload.data.historyList,
        marketId: payload.marketId,
        totalCount: payload.data.totalCount,
        canLoadMore: payload.data.totalCount > payload.data.historyList.length,
      };
    },
    setOpenRules(state, payload) {
      state.isRulesOpen = payload;
    },
    setRelatedMarkets(state, payload) {
      state.related = payload;
    },
    clearRelatedMarkets(state) {
      state.related = [];
    },
    updateRelatedMarketFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(market => updateMarket(market, data));
      }
    },
    updateRelatedContractFromNotification(state, data) {
      if (state.related.length > 0) {
        state.related = state.related.map(market => updateMarketContracts(market, data));
      }
    },
    setChartTimeline(state, data) {
      state.chartTimeline = data;
    },
    setChartType(state, data) {
      state.chartType = data;
    },
    setMarketContractsStats(state, data) {
      state.marketContractsStats = data;
    },
    clearMarketContractsStats(state) {
      state.marketContractsStats = [];
    },
    setMapOverviewData(state, data) {
      state.mapOverviewData = data;
    },
    setMapOverviewDataSenate(state, data) {
      state.mapOverviewDataSenate = data;
    },
    setMapStateData(state, data) {
      state.mapStateData = data;
    },
    setMapStateDataSenate(state, data) {
      state.mapStateDataSenate = data;
    },
    setMarketMapTooltipVisible(state, flag) {
      state.marketMapTooltipVisible = flag;
    },
  },
  actions: {
    clearMarket({ commit }) {
      commit('setMarket', {});
      commit('setContracts', []);
    },
    clearMarketEngineBusyMessage({ commit }) {
      commit('setMarketEngineBusyMessage', {
        isEngineBusy: false,
        isEngineBusyMessage: null,
      });
    },
    getMarket({ commit, dispatch, state }, { marketId, commentThreadId = '', skipCache = false, modifyState = true }) {
      commit('setMarketLoadError', false);
      if (!skipCache && state.market !== null && state.market.marketId === marketId) {
        return Promise.resolve(state.market);
      }
      let marketData = {};
      return api.market.getMarket(marketId, commentThreadId)
        .then((response) => {
          marketData = response.data;
        })
        .then(() => api.market.getMarketContracts(marketId))
        .then((response) => {
          marketData.contracts = response.data;
          if (modifyState) {
            commit('setContracts', marketData.contracts);
            commit('setMarket', marketData);
          }
          return marketData;
        })
        .catch(() => {
          if (modifyState) {
            commit('setMarketLoadError', true);
            dispatch('clearMarket');
          }
        });
    },
    getMarketRules({ commit }, marketId) {
      return api.market.getMarketRules(marketId)
        .then(response => response.data);
    },
    getContract({ commit, state }, contractId) {
      if (state.contract !== null && state.contract.contractId === contractId) {
        return Promise.resolve(state.contract);
      }
      if (state.contracts !== null) {
        const contract = state.contracts.find(c => c.contractId === contractId);
        if (typeof contract !== 'undefined') {
          commit('setContract', contract);
          return Promise.resolve(contract);
        }
      }
      return Promise.resolve();
    },
    getMarketContractsStats({ commit, dispatch }, marketId) {
      return api.market.getMarketContractsStats(marketId)
        .then((response) => {
          commit('setMarketContractsStats', response.data);
          return response.data;
        })
        .catch(() => {
          dispatch('clearMarketContractsStats');
        });
    },
    clearMarketContractsStats({ commit }) {
      commit('clearMarketContractsStats');
    },
    resetHistory({ commit }) {
      commit('resetHistory');
    },
    getMarketHistory({ state, commit }, marketId) {
      const history = state.history;
      if (history !== null && history.marketId === marketId) {
        return history.data;
      }
      // on new market but in history old data
      commit('resetHistory');
      return api.profile.getTradeHistory(ITEMS_PER_HISTORY_PAGE, 1, marketId)
        .then((response) => {
          commit('updateHistory', {
            data: response.data,
            marketId,
          });
          return response.data;
        });
    },
    getRelatedMarkets({ commit }, marketId) {
      return api.market.getMarketRelated(marketId)
        .then((response) => {
          const data = response.data.slice(0, MAX_RELATED_MARKETS);
          commit('setRelatedMarkets', data);
          return data;
        });
    },
    clearRelatedMarkets({ commit }) {
      commit('clearRelatedMarkets');
    },
    updateMarketFromNotification({ commit, dispatch, state }, payload) {
      const marketId = payload.MarketId;
      if (state.market !== null && state.market.marketId === marketId) {
        commit('updateMarketFromNotification', payload);
        // debounceGetMarket(dispatch, marketId);
      }
    },
    setMarketEngineBusyMessage({ commit }, payload) {
      commit('setMarketEngineBusyMessage', payload);
    },
    updateRelatedMarketFromNotification({ commit }, payload) {
      commit('updateRelatedMarketFromNotification', payload);
    },
    updateRelatedContractFromNotification({ commit }, payload) {
      commit('updateRelatedContractFromNotification', payload);
    },
    updateContractFromNotification({ commit }, payload) {
      commit('updateContractFromNotification', payload);
    },
    updateMapOverviewDataFromNotification({ commit }, payload) {
      commit('updateMapOverviewDataFromNotification', payload);
    },
    updateMapOverviewDataSenateFromNotification({ commit }, payload) {
      commit('updateMapOverviewDataSenateFromNotification', payload);
    },
    openRules({ commit }, payload = true) {
      commit('setOpenRules', payload);
    },
    setMarket({ commit }, market) {
      commit('setMarket', market);
    },
    setContracts({ commit }, contracts) {
      commit('setContracts', contracts);
    },
    setMarketLoadError({ commit }, flag) {
      commit('setMarketLoadError', flag);
    },
    setChartTimeline({ commit }, payload) {
      commit('setChartTimeline', payload);
    },
    setChartType({ commit }, payload) {
      commit('setChartType', payload);
    },
    getMapOverviewData({ commit }) {
      return api.map.getContracts()
        .then((response) => {
          commit('setMapOverviewData', response.data);
          return response.data;
        });
    },
    getMapStateData({ commit }) {
      return api.map.getStateData()
        .then((response) => {
          const data = (response.data || []).reduce((obj, item) => {
            const stateCode = item.marketName.split(' ')[4];
            const stateName = constants.statesCodeToNameMap[stateCode];
            const stateVotes = constants.statesCodeToElectoralVotesMap[stateCode];
            obj[stateCode] = {
              ...item,
              stateVotes,
              stateCode,
              stateName,
            };
            return obj;
          }, {});
          commit('setMapStateData', data);
          return data;
        });
    },
    getMapOverviewDataSenate({ commit }) {
      return api.map.getContractsSenate()
        .then((response) => {
          commit('setMapOverviewDataSenate', response.data);
          return response.data;
        });
    },
    getMapStateDataSenate({ commit }) {
      return api.map.getStateDataSenate()
        .then((response) => {
          const data = (response.data || []).reduce((obj, item) => {
            const stateCode = item.marketName.match(/\b[A-Z]{2}\b/)[0];
            const stateName = constants.statesCodeToNameMap[stateCode];
            const stateVotes = constants.statesCodeToElectoralVotesMap[stateCode];
            const result = {
              ...item,
              stateVotes,
              stateCode,
              stateName,
            };
            // if (stateCode === 'GA') {
            //   if (item.marketId === 6651) {
            //     obj[stateCode] = result;
            //   } else {
            //     obj.GA2 = result;
            //   }
            // }
            obj[stateCode] = result;
            return obj;
          }, {});
          commit('setMapStateDataSenate', data);
          return data;
        });
    },
    setMarketMapTooltipVisible({ commit }, flag) {
      commit('setMarketMapTooltipVisible', flag);
    },
    getCommentThread({ commit }, { marketId, threadId }) {
      return api.market.getCommentThread({ marketId, threadId })
        .then(response => response.data);
    },
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/market.js